(() => {
  const header = document.querySelector('[data-dc-header]');
  if (!header) return;
  const toggle = header.querySelector('[data-dc-menu-toggle]');
  const drawer = header.querySelector('[data-dc-mobile-drawer]');
  const overlay = header.querySelector('[data-dc-overlay]');
  const close = header.querySelector('[data-dc-menu-close]');
  const mega = header.querySelector('[data-dc-mega-menu]');
  const triggers = header.querySelectorAll('[data-dc-menu-trigger]');
  const setMobileOpen = (open) => {
    header.classList.toggle('dc-mobile-open', open);
    toggle?.setAttribute('aria-expanded', String(open));
    drawer?.setAttribute('aria-hidden', String(!open));
    document.documentElement.classList.toggle('dc-no-scroll', open);
  };
  toggle?.addEventListener('click', () => setMobileOpen(!header.classList.contains('dc-mobile-open')));
  close?.addEventListener('click', () => setMobileOpen(false));
  overlay?.addEventListener('click', () => setMobileOpen(false));
  const panels = [...header.querySelectorAll('[data-dc-panel]')];
  const closeMega = () => {
    mega?.classList.remove('is-open');
    mega?.setAttribute('aria-hidden', 'true');
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
  };
  const openMega = (trigger, index) => {
    if (!window.matchMedia('(min-width: 821px)').matches) return;
    const panelIndex = trigger.dataset.dcMenuIndex ?? String(index);
    mega?.classList.add('is-open');
    mega?.setAttribute('aria-hidden', 'false');
    triggers.forEach((item) => item.setAttribute('aria-expanded', String(item === trigger)));
    panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.dcPanel === panelIndex));
  };
  triggers.forEach((trigger, index) => {
    trigger.addEventListener('mouseenter', () => openMega(trigger, index));
    trigger.addEventListener('focus', () => openMega(trigger, index));
    trigger.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      openMega(trigger, index);
      mega?.querySelector('.is-active a')?.focus();
    });
  });
  header.querySelectorAll('.dc-nav-link:not([data-dc-menu-trigger]), .dc-utility-nav, .dc-wordmark').forEach((item) => {
    item.addEventListener('mouseenter', closeMega);
    item.addEventListener('focusin', closeMega);
  });
  header.addEventListener('mouseleave', closeMega);
  header.addEventListener('focusout', (event) => {
    if (!header.contains(event.relatedTarget)) closeMega();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !mega?.classList.contains('is-open')) return;
    const activeTrigger = [...triggers].find((trigger) => trigger.getAttribute('aria-expanded') === 'true');
    if (mega.contains(document.activeElement)) activeTrigger?.focus();
    closeMega();
  });
  window.addEventListener('resize', closeMega);
})();

(() => {
  const page = document.querySelector('[data-product-page]');
  const drawer = page?.querySelector('[data-size-guide-drawer]');
  if (!page || !drawer) return;
  const openTrigger = page.querySelector('[data-size-guide-open]');
  const closeButtons = drawer.querySelectorAll('[data-size-guide-close]');
  let lastFocused = null;
  const close = () => {
    drawer.hidden = true;
    drawer.dataset.open = 'false';
    document.documentElement.classList.remove('dc-no-scroll');
    lastFocused?.focus?.();
  };
  const open = () => {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    drawer.dataset.open = 'true';
    document.documentElement.classList.add('dc-no-scroll');
    drawer.querySelector('[data-size-guide-close]')?.focus();
  };
  openTrigger?.addEventListener('click', open);
  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !drawer.hidden) close(); });
})();

(() => {
  const header = document.querySelector('[data-dc-header]');
  const panel = header?.querySelector('[data-dc-search-panel]');
  if (!header || !panel) return;

  const triggers = [...header.querySelectorAll('[data-dc-search-trigger]')];
  const form = panel.querySelector('[data-dc-search-form]');
  const input = panel.querySelector('[data-dc-search-input]');
  const clear = panel.querySelector('[data-dc-search-clear]');
  const status = panel.querySelector('[data-dc-search-status]');
  const results = panel.querySelector('[data-dc-search-results]');
  const allResults = panel.querySelector('[data-dc-search-all]');
  let timer;
  let requestController;
  let activeIndex = -1;
  let open = false;

  const setOpen = (next) => {
    open = next;
    panel.hidden = !next;
    panel.classList.toggle('is-open', next);
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(next)));
    document.documentElement.classList.toggle('dc-no-scroll', next);
    if (next) window.requestAnimationFrame(() => input?.focus());
  };
  const setQueryUrl = (query) => {
    if (!allResults) return;
    allResults.href = query ? `${allResults.dataset.baseUrl}?q=${encodeURIComponent(query)}` : allResults.dataset.baseUrl;
  };
  if (allResults) allResults.dataset.baseUrl = allResults.getAttribute('href') || '/search';
  const clearResults = () => {
    if (results) results.replaceChildren();
    activeIndex = -1;
  };
  const productList = (payload) => payload?.resources?.results?.products || payload?.products || [];
  const renderResults = (products, query) => {
    clearResults();
    if (!products.length) {
      if (status) status.textContent = query ? 'No products found. Try another search.' : 'Search for shoes, boots, or loafers.';
      return;
    }
    if (status) status.textContent = `${products.length} result${products.length === 1 ? '' : 's'}`;
    products.slice(0, 6).forEach((product) => {
      const link = document.createElement('a');
      link.className = 'dc-search-result';
      link.href = product.url || '#';
      link.setAttribute('role', 'option');
      const media = document.createElement('span');
      media.className = 'dc-search-result__media';
      const imageUrl = product.image || product.featured_image?.url;
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = product.title || '';
        image.loading = 'lazy';
        media.append(image);
      }
      const copy = document.createElement('span');
      copy.className = 'dc-search-result__copy';
      const title = document.createElement('span');
      title.className = 'dc-search-result__title';
      title.textContent = product.title || 'Product';
      const price = document.createElement('span');
      price.className = 'dc-search-result__price';
      price.textContent = product.price || product.price_min || '';
      copy.append(title, price);
      link.append(media, copy);
      results?.append(link);
    });
  };
  const fetchResults = async (query) => {
    requestController?.abort();
    if (!query || query.length < 2) {
      clearResults();
      if (status) status.textContent = 'Search for shoes, boots, or loafers.';
      return;
    }
    requestController = new AbortController();
    if (status) status.textContent = 'Searching…';
    try {
      const endpoint = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[options][unavailable_products]=hide&resources[limit]=6`;
      const response = await fetch(endpoint, { signal: requestController.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Search request failed: ${response.status}`);
      renderResults(productList(await response.json()), query);
    } catch (error) {
      if (error.name === 'AbortError') return;
      clearResults();
      if (status) status.textContent = 'Search is temporarily unavailable. View all results below.';
    }
  };
  const queueSearch = () => {
    const query = input?.value.trim() || '';
    if (clear) clear.hidden = !query;
    setQueryUrl(query);
    window.clearTimeout(timer);
    timer = window.setTimeout(() => fetchResults(query), 180);
  };
  const setActive = (index) => {
    const items = [...(results?.querySelectorAll('.dc-search-result') || [])];
    if (!items.length) return;
    activeIndex = (index + items.length) % items.length;
    items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
    items[activeIndex].scrollIntoView({ block: 'nearest' });
  };
  triggers.forEach((trigger) => trigger.addEventListener('click', () => setOpen(!open)));
  input?.addEventListener('input', queueSearch);
  clear?.addEventListener('click', () => { input.value = ''; queueSearch(); input.focus(); });
  form?.addEventListener('submit', (event) => {
    const query = input?.value.trim() || '';
    if (!query) event.preventDefault();
  });
  input?.addEventListener('keydown', (event) => {
    const items = [...(results?.querySelectorAll('.dc-search-result') || [])];
    if (event.key === 'ArrowDown' && items.length) { event.preventDefault(); setActive(activeIndex + 1); }
    if (event.key === 'ArrowUp' && items.length) { event.preventDefault(); setActive(activeIndex - 1); }
    if (event.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) { event.preventDefault(); items[activeIndex].click(); }
    if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
  });
  document.addEventListener('click', (event) => { if (open && !header.contains(event.target)) setOpen(false); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && open) setOpen(false); });
})();

(() => {
  const page = document.querySelector('[data-product-page]');
  const dialog = page?.querySelector('[data-size-finder-dialog]');
  if (!page || !dialog) return;

  const introImage = dialog.querySelector('[data-size-finder-intro-image]');
  const sourceImage = page.querySelector('.product-gallery-image img');
  if (introImage && sourceImage) {
    introImage.src = sourceImage.currentSrc || sourceImage.src;
    introImage.alt = sourceImage.alt || '';
  }

  const SIZE_FINDER_QUESTIONS = [
    { key: 'brannock', title: 'What size do you usually wear?' },
    { key: 'formal-shoe', title: 'What size fits you best in formal shoes?' },
    { key: 'width', title: 'How would you describe your foot width?' },
    { key: 'fit', title: 'How much room do you prefer in the toe box?' },
    { key: 'sock', title: 'What will you usually wear with this pair?' },
  ];

  const views = [...dialog.querySelectorAll('[data-size-finder-step]')];
  const questionSections = [...dialog.querySelectorAll('[data-size-finder-question]')];
  const openTrigger = page.querySelector('[data-size-finder-open]');
  const closeButtons = dialog.querySelectorAll('[data-size-finder-close]');
  const startButton = dialog.querySelector('[data-size-finder-start]');
  const backButton = dialog.querySelector('[data-size-finder-back]');
  const unknownButton = dialog.querySelector('[data-size-finder-unknown]');
  const skipButton = dialog.querySelector('[data-size-finder-skip]');
  const applyButton = dialog.querySelector('[data-size-finder-apply]');
  const restartButton = dialog.querySelector('[data-size-finder-restart]');
  const progress = dialog.querySelector('[data-size-finder-progress]');
  const questionTitle = dialog.querySelector('[data-size-finder-question-title]');
  const resultSize = dialog.querySelector('[data-size-finder-result-size]');
  const resultCopy = dialog.querySelector('[data-size-finder-result-copy]');
  const form = page.querySelector('[data-product-form]');
  const sizeInputs = [...(form?.querySelectorAll('[data-variant-id-option]') || [])];
  const availableVariants = (() => {
    try {
      const variants = JSON.parse(page.dataset.variantJson || '[]');
      return variants.filter((variant) => variant.available !== false);
    } catch (error) {
      return [];
    }
  })();

  const uniqueSizes = (variants) => [...new Set(variants.map((variant) => String(variant.options?.at(-1) || variant.title?.split(' / ').pop() || '').trim()).filter(Boolean))];
  const availableSizes = uniqueSizes(availableVariants);
  const numericSize = (value) => Number.parseFloat(String(value).replace(/[^0-9.]/g, ''));
  const nearestSize = (target, sizes) => sizes.sort((a, b) => Math.abs(numericSize(a) - target) - Math.abs(numericSize(b) - target))[0] || '';
  const recommendSize = (answers, variants) => {
    const sizes = uniqueSizes(variants);
    const base = numericSize(answers.brannock || answers['formal-shoe']);
    if (!Number.isFinite(base)) return sizes[0] || '';
    let target = base;
    if (answers.width === 'wide' || answers.fit === 'roomy' || answers.sock === 'thick') target += 0.5;
    if (answers.width === 'narrow' || answers.fit === 'close') target -= 0.5;
    return nearestSize(target, sizes);
  };

  const state = {
    open: false,
    view: 'intro',
    step: 0,
    answers: { brannock: null, 'formal-shoe': null, width: null, fit: null, sock: null },
    recommendation: null,
    lastFocused: null,
  };

  const setView = (name) => {
    state.view = name;
    views.forEach((view) => { view.hidden = view.dataset.sizeFinderStep !== name; });
  };
  const currentSection = () => questionSections.find((section) => Number(section.dataset.sizeFinderQuestionIndex) === state.step);
  const renderStep = () => {
    const question = SIZE_FINDER_QUESTIONS[state.step];
    if (!question) return;
    setView('questions');
    questionSections.forEach((section) => { section.hidden = section.dataset.sizeFinderQuestion !== question.key; });
    if (progress) progress.textContent = `Step ${state.step + 1} of ${SIZE_FINDER_QUESTIONS.length}`;
    if (questionTitle) questionTitle.textContent = question.title;
  };
  const open = () => {
    state.open = true;
    state.lastFocused = document.activeElement;
    dialog.hidden = false;
    dialog.dataset.open = 'true';
    document.documentElement.classList.add('dc-no-scroll');
    setView('intro');
    dialog.querySelector('[data-size-finder-close]')?.focus();
  };
  const close = () => {
    state.open = false;
    dialog.hidden = true;
    dialog.dataset.open = 'false';
    document.documentElement.classList.remove('dc-no-scroll');
    state.lastFocused?.focus?.();
  };
  const advance = () => {
    if (state.step >= SIZE_FINDER_QUESTIONS.length - 1) {
      state.recommendation = recommendSize(state.answers, availableVariants);
      if (resultSize) resultSize.textContent = state.recommendation ? `${state.recommendation}` : 'Choose a size manually';
      if (resultCopy) resultCopy.textContent = state.recommendation ? `Based on your answers, ${state.recommendation} is the closest available size for this product.` : 'We could not find a confident match. Please choose a size manually.';
      setView('result');
      return;
    }
    state.step += 1;
    renderStep();
  };
  const answer = (key, value) => {
    state.answers[key] = value;
    advance();
  };
  const reset = () => {
    state.step = 0;
    state.answers = { brannock: null, 'formal-shoe': null, width: null, fit: null, sock: null };
    state.recommendation = null;
    renderStep();
  };

  const formalOptions = dialog.querySelector('[data-size-finder-formal-options]');
  if (formalOptions) {
    availableSizes.forEach((size) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.sizeFinderAnswer = 'formal-shoe';
      button.dataset.sizeFinderValue = size;
      button.textContent = `${size}`;
      formalOptions.append(button);
    });
  }
  dialog.querySelectorAll('[data-size-finder-answer]').forEach((button) => button.addEventListener('click', () => answer(button.dataset.sizeFinderAnswer, button.dataset.sizeFinderValue)));
  openTrigger?.addEventListener('click', (event) => { event.preventDefault(); open(); });
  startButton?.addEventListener('click', () => { reset(); dialog.querySelector('[data-size-finder-answer]')?.focus(); });
  backButton?.addEventListener('click', () => { if (state.step > 0) { state.step -= 1; renderStep(); } else setView('intro'); });
  unknownButton?.addEventListener('click', () => advance());
  skipButton?.addEventListener('click', () => advance());
  restartButton?.addEventListener('click', reset);
  applyButton?.addEventListener('click', () => {
    const input = sizeInputs.find((item) => item.value === state.recommendation && !item.disabled);
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    try { sessionStorage.setItem(`divinch-size-finder:${page.dataset.productId || location.pathname}`, state.recommendation); } catch (error) { /* storage is optional */ }
    close();
  });
  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && state.open) close(); });
})();

(() => {
  const grid = document.querySelector('[data-related-fallback]');
  if (!grid) return;
  const cards = [...grid.querySelectorAll('.product-card')];
  for (let index = cards.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [cards[index], cards[swapIndex]] = [cards[swapIndex], cards[index]];
  }
  if (cards.length > 4) cards.forEach((card, index) => { card.hidden = index >= 4; });
})();

(() => {
  const page = document.querySelector('[data-product-page]');
  if (!page) return;

  const gallery = page.querySelector('.product-gallery');
  if (!gallery) return;
  const galleryStage = gallery.querySelector('.product-gallery-stage');
  const galleryButtons = [...gallery.querySelectorAll('[data-gallery-target]')];
  const galleryMedia = [...gallery.querySelectorAll('[data-product-media]')];
  const prefersReducedMotion = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const setVideoStageRatio = (video) => {
    if (!galleryStage) return;
    const width = Number(video?.videoWidth || 0);
    const height = Number(video?.videoHeight || 0);
    galleryStage.style.setProperty('--product-media-ratio', width > 0 && height > 0 ? `${width} / ${height}` : '9 / 16');
  };
  const playVideo = (video) => {
    if (!video || prefersReducedMotion() || navigator.connection?.saveData) return;
    video.muted = true;
    const promise = video.play();
    promise?.catch?.(() => {});
  };
  const activateVideo = (video) => {
    if (!video || video.dataset.videoActivated === 'true') return;
    video.querySelectorAll('source[data-video-src]').forEach((source) => {
      if (!source.src) source.src = source.dataset.videoSrc;
    });
    video.muted = true;
    video.playsInline = true;
    video.dataset.videoActivated = 'true';
    video.addEventListener('loadedmetadata', () => {
      setVideoStageRatio(video);
      playVideo(video);
    }, { once: true });
    video.load();
    if (video.readyState >= 1) {
      setVideoStageRatio(video);
      playVideo(video);
    }
  };
  const selectGalleryButton = (button) => {
    if (!button) return;
    const target = button.dataset.galleryTarget;
    galleryButtons.forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-current', String(active));
    });
    const activeMedia = galleryMedia.find((media) => media.dataset.productMedia === target);
    const isVideo = activeMedia?.dataset.mediaType === 'video';
    galleryStage?.classList.toggle('is-video-active', isVideo);
    if (!isVideo) galleryStage?.style.removeProperty('--product-media-ratio');
    galleryMedia.forEach((media) => {
      const active = media.dataset.productMedia === target;
      media.classList.toggle('is-hidden', !active);
      media.setAttribute('aria-hidden', String(!active));
      media.querySelectorAll('video[data-product-video]').forEach((video) => {
        if (active) activateVideo(video);
        else video.pause();
      });
    });
    button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };
  galleryButtons.forEach((button) => button.addEventListener('click', () => selectGalleryButton(button)));
  const initialGalleryButton = galleryButtons.find((button) => button.classList.contains('is-active')) || galleryButtons[0];
  const initialMedia = galleryMedia.find((media) => media.dataset.productMedia === initialGalleryButton?.dataset.galleryTarget);
  galleryStage?.classList.toggle('is-video-active', initialMedia?.dataset.mediaType === 'video');
  initialMedia?.querySelectorAll('video[data-product-video]').forEach(activateVideo);
  const moveGallery = (direction) => {
    const activeIndex = Math.max(0, galleryButtons.findIndex((button) => button.classList.contains('is-active')));
    const nextIndex = (activeIndex + direction + galleryButtons.length) % galleryButtons.length;
    selectGalleryButton(galleryButtons[nextIndex]);
  };
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => moveGallery(-1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => moveGallery(1));
  const lightbox = gallery.querySelector('[data-product-lightbox]');
  const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
  const openLightbox = () => {
    const activeImage = gallery.querySelector('[data-product-media]:not(.is-hidden)[data-media-type="image"] img');
    if (!lightbox || !lightboxImage || !activeImage) return;
    lightboxImage.src = activeImage.currentSrc || activeImage.src;
    lightboxImage.alt = activeImage.alt || '';
    lightbox.hidden = false;
    page.classList.add('is-lightbox-open');
    document.documentElement.classList.add('dc-no-scroll');
    lightbox.querySelector('[data-lightbox-close]')?.focus();
  };
  const closeLightbox = () => {
    if (!lightbox) return;
    lightbox.hidden = true;
    page.classList.remove('is-lightbox-open');
    document.documentElement.classList.remove('dc-no-scroll');
  };
  gallery.querySelectorAll('[data-product-media][data-media-type="image"] img').forEach((image) => image.addEventListener('click', openLightbox));
  lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
  lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });
  lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => { moveGallery(-1); openLightbox(); });
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => { moveGallery(1); openLightbox(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && lightbox && !lightbox.hidden) closeLightbox(); });
  let pinchStartDistance = 0;
  let pinchStartScale = 1;
  const touchDistance = (touches) => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
  lightboxImage?.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 2) return;
    pinchStartDistance = touchDistance(event.touches);
    pinchStartScale = Number(lightboxImage.dataset.zoomScale || 1);
  }, { passive: true });
  lightboxImage?.addEventListener('touchmove', (event) => {
    if (event.touches.length !== 2 || !pinchStartDistance) return;
    const scale = Math.min(4, Math.max(1, pinchStartScale * (touchDistance(event.touches) / pinchStartDistance)));
    lightboxImage.dataset.zoomScale = String(scale);
    lightboxImage.style.transform = `scale(${scale})`;
  }, { passive: true });
  lightboxImage?.addEventListener('touchend', () => { pinchStartDistance = 0; }, { passive: true });
  let touchStartX = null;
  let touchStartY = null;
  let touchMoved = false;
  let suppressGalleryClickUntil = 0;
  galleryStage?.addEventListener('touchstart', (event) => {
    touchStartX = event.changedTouches[0]?.clientX ?? null;
    touchStartY = event.changedTouches[0]?.clientY ?? null;
    touchMoved = false;
  }, { passive: true });
  galleryStage?.addEventListener('touchmove', (event) => {
    if (touchStartX === null || touchStartY === null) return;
    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - touchStartX;
    const deltaY = touch.clientY - touchStartY;
    if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
      touchMoved = true;
      event.preventDefault();
    }
  }, { passive: false });
  galleryStage?.addEventListener('touchend', (event) => {
    if (touchStartX === null) return;
    const delta = event.changedTouches[0]?.clientX - touchStartX;
    const didSwipe = touchMoved && Math.abs(delta) > 45;
    touchStartX = null;
    touchStartY = null;
    touchMoved = false;
    if (didSwipe) {
      suppressGalleryClickUntil = Date.now() + 350;
      moveGallery(delta < 0 ? 1 : -1);
    }
  }, { passive: true });
  galleryStage?.addEventListener('click', (event) => {
    if (Date.now() < suppressGalleryClickUntil) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  const form = page.querySelector('[data-product-form]');
  if (!form) return;
  const variants = (() => {
    try { return JSON.parse(page.dataset.variantJson || '[]'); } catch (error) { return []; }
  })();
  const variantId = form.querySelector('[data-variant-id]');
  const landingActive = Boolean(page.dataset.lpAngle);
  const sku = form.querySelector('[data-product-sku]');
  let submitting = false;
  const addButton = form.querySelector('[data-add-to-cart]');
  const addButtonLabel = addButton?.querySelector('[data-add-to-cart-label]');
  const mobileBar = page.querySelector('[data-mobile-buy-bar]');
  const mobileButton = mobileBar?.querySelector('[data-mobile-buy]');
  const mobileButtonLabel = mobileButton?.querySelector('[data-mobile-buy-label]');
  const price = page.querySelector('[data-product-price]');
  const mobilePrice = mobileBar?.querySelector('[data-mobile-price]');
  const mobileColor = mobileBar?.querySelector('[data-mobile-color]');
  const mobileSize = mobileBar?.querySelector('[data-mobile-size]');
  const selectionMessage = form.querySelector('[data-selection-message]');
  const sizeGroup = form.querySelector('[data-size-group]');
  const showAllSizesButton = form.querySelector('[data-size-show-all]');
  const showAllSizesText = showAllSizesButton?.querySelector('[data-size-show-all-text]');
  const showAllSizesIcon = showAllSizesButton?.querySelector('[data-size-show-all-icon]');
  const sizeGrid = form.querySelector('.size-grid');
  const sizeInputs = [...form.querySelectorAll('[data-variant-id-option]')];
  const colorOptions = [...form.querySelectorAll('[data-color-value]')];
  const selectedSize = form.querySelector('[data-selected-size]');
  const selectedColor = form.querySelector('[data-selected-color]');
  const defaultColor = colorOptions.find((button) => button.dataset.colorDefault === 'true');
  let activeColor = defaultColor?.dataset.colorValue || '';

  const money = (value) => `$${(Number(value || 0) / 100).toFixed(2)}`;
  const chosenSize = () => form.querySelector('input[name="product-size"]:checked')?.value || '';
  const findVariant = () => {
    const size = chosenSize();
    if (!size && sizeInputs.length) return null;
    return variants.find((variant) => {
      const lastOption = variant.options?.[variant.options.length - 1] || variant.title?.split(' / ').pop();
      const colorMatches = !activeColor || variant.options?.[0] === activeColor;
      return (!size || lastOption === size) && colorMatches && variant.available;
    }) || variants.find((variant) => variant.available);
  };

  const announceSizeRequired = () => {
    if (selectionMessage) selectionMessage.textContent = 'Please select a size first.';
    sizeGroup?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    sizeGroup?.focus({ preventScroll: true });
  };

  const setVariantState = () => {
    const variant = findVariant();
    const ready = Boolean(variant?.id && variant.available);
    const label = ready ? 'ADD TO CART' : 'SELECT YOUR SIZE';
    if (variantId) variantId.value = ready ? variant.id : '';
    if (landingActive && sku) {
      sku.textContent = ready && variant.sku ? `SKU: ${variant.sku}` : '';
      sku.hidden = !ready || !variant.sku;
    }
    if (price && ready) price.textContent = money(variant.price);
    if (mobilePrice && ready) mobilePrice.textContent = money(variant.price);
    if (mobileSize) mobileSize.textContent = chosenSize() ? `${chosenSize()}` : 'Choose a size';
    if (mobileColor) mobileColor.textContent = activeColor || 'Choose a color';
    if (selectedSize) selectedSize.textContent = chosenSize() ? `- ${chosenSize()}` : 'Choose a size';
    if (selectedColor) selectedColor.textContent = activeColor || 'Choose a color';
    if (selectionMessage && ready) selectionMessage.textContent = '';
    form.classList.toggle('is-ready', ready);
    if (addButton) {
      addButton.disabled = landingActive && submitting;
      addButton.setAttribute('aria-disabled', String(!ready || (landingActive && submitting)));
    }
    if (addButtonLabel) addButtonLabel.textContent = label;
    if (mobileButtonLabel) mobileButtonLabel.textContent = label;
    if (mobileButton) {
      mobileButton.disabled = landingActive && submitting;
      mobileButton.setAttribute('aria-disabled', String(!ready || (landingActive && submitting)));
    }
  };

  sizeInputs.forEach((input) => input.addEventListener('change', setVariantState));
  colorOptions.forEach((button) => button.addEventListener('click', () => {
    activeColor = button.dataset.colorValue || '';
    colorOptions.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    setVariantState();
  }));
  if (defaultColor) colorOptions.forEach((button) => button.setAttribute('aria-pressed', String(button === defaultColor)));
  showAllSizesButton?.addEventListener('click', () => {
    const expanded = showAllSizesButton.getAttribute('aria-expanded') === 'true';
    showAllSizesButton.setAttribute('aria-expanded', String(!expanded));
    if (showAllSizesText) showAllSizesText.textContent = expanded ? 'Show all sizes' : 'Show fewer sizes';
    else showAllSizesButton.textContent = expanded ? 'Show all sizes' : 'Show fewer sizes';
    if (showAllSizesIcon) showAllSizesIcon.hidden = !expanded;
    form.querySelectorAll('.size-grid-option.is-progressive-hidden').forEach((option) => { option.hidden = expanded; });
    if (!expanded) sizeGrid?.append(showAllSizesButton);
  });
  form.addEventListener('submit', async (event) => {
    if (landingActive && submitting) { event.preventDefault(); return; }
    if (!variantId?.value) {
      event.preventDefault();
      announceSizeRequired();
      return;
    }
    if (!document.querySelector('[data-cart-drawer]')) return;
    event.preventDefault();
    submitting = true;
    if (addButton) addButton.disabled = true;
    if (landingActive && mobileButton) mobileButton.disabled = true;
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId.value), quantity: Number(form.querySelector('[name="quantity"]')?.value || 1) }] }),
      });
      if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
      window.dispatchEvent(new CustomEvent('dc:cart-added'));
    } catch (error) {
      console.error('[DIVINCH] Cart add failed', error);
      form.submit();
    } finally {
      submitting = false;
      setVariantState();
    }
  });
  mobileButton?.addEventListener('click', () => {
    if (!variantId?.value) {
      announceSizeRequired();
      return;
    }
    addButton?.click();
  });
  if (landingActive) {
    const linked = new URLSearchParams(location.search).getAll('variant');
    const variant = linked.length === 1 && /^\d+$/.test(linked[0])
      ? variants.find(item => String(item.id) === linked[0] && item.available)
      : null;
    if (variant) {
      const color = colorOptions.find(item => item.dataset.colorValue === variant.options?.[0]);
      if (color) {
        activeColor = color.dataset.colorValue;
        colorOptions.forEach(item => item.setAttribute('aria-pressed', String(item === color)));
      }
      const input = sizeInputs.find(item => item.value === variant.options?.at(-1) && !item.disabled);
      if (input) input.checked = true;
    }
  }
  setVariantState();
})();

(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const panel = drawer.querySelector('.dc-cart-drawer__panel');
  const itemsContainer = drawer.querySelector('[data-cart-drawer-items]');
  const subtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const money = (value) => `$${(Number(value || 0) / 100).toFixed(2)}`;
  let lastFocused = null;
  let cart = null;

  const setCartCount = (count) => document.querySelectorAll('.dc-cart sup, .dc-mobile-drawer__actions .dc-icon-link sup').forEach((node) => { node.textContent = String(count); });
  const render = () => {
    const items = cart?.items || [];
    setCartCount(cart?.item_count || 0);
    if (subtotal) subtotal.textContent = money(cart?.total_price);
    if (!items.length) {
      itemsContainer.innerHTML = '<p class="dc-cart-drawer__empty">Your bag is empty.</p>';
      return;
    }
    itemsContainer.innerHTML = items.map((item) => `<article class="dc-cart-drawer__item"><span class="dc-cart-drawer__quantity">${item.quantity}</span><img src="${escapeHtml(item.image || '')}" alt="${escapeHtml(item.product_title)}"><div class="dc-cart-drawer__item-copy"><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(item.variant_title || '')}</p><button type="button" data-cart-drawer-remove data-line-key="${escapeHtml(item.key)}">REMOVE</button></div><strong>${money(item.final_line_price)}</strong></article>`).join('');
    itemsContainer.querySelectorAll('[data-cart-drawer-remove]').forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      await fetch('/cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: button.dataset.lineKey, quantity: 0 }) });
      await loadCart();
    }));
  };
  const loadCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
    cart = await response.json();
    render();
    return cart;
  };
  const setOpen = (open) => {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.documentElement.classList.toggle('dc-no-scroll', open);
    if (open) panel?.querySelector('[data-cart-drawer-close]')?.focus();
    else lastFocused?.focus?.();
  };
  const open = async () => {
    lastFocused = document.activeElement;
    try { await loadCart(); } catch (error) { console.error('[DIVINCH] Cart drawer load failed', error); }
    setOpen(true);
  };
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', () => setOpen(false)));
  document.querySelectorAll('.dc-cart').forEach((link) => link.addEventListener('click', (event) => { event.preventDefault(); open(); }));
  window.addEventListener('dc:cart-added', open);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });
})();

(() => {
  const sentinel = document.querySelector('[data-dc-infinite-scroll]');
  const grid = document.querySelector('.collection-product-grid');
  const reviewSource = document.querySelector('[data-dc-ugc-review]');
  const judgeMeReviewData = window.jdgm?.data?.reviewWidget || {};
  if (!grid) return;

  const parseReviewData = (value) => {
    if (!value) return null;
    try {
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (error) {
      return null;
    }
  };

  const collectReviewsWithMedia = (value, depth = 0, results = []) => {
    if (!value || depth > 6) return results;
    if (Array.isArray(value)) {
      value.forEach((item) => collectReviewsWithMedia(item, depth + 1, results));
      return results;
    }
    if (typeof value !== 'object') return results;
    const media = value.media || value.medias || value.photos || value.images || value.pictures_urls;
    if (Array.isArray(media) && media.length) {
      results.push({ ...value, media });
      return results;
    }
    Object.values(value).forEach((child) => collectReviewsWithMedia(child, depth + 1, results));
    return results;
  };

  const mediaUrl = (media) => {
    const first = Array.isArray(media) ? media[0] : media;
    if (typeof first === 'string') return first;
    return first?.url || first?.src || first?.original_url || first?.original || first?.huge || '';
  };

  const plainReviewText = (value) => {
    const template = document.createElement('template');
    template.innerHTML = String(value || '')
      .replace(/<br\b[^>]*>/gi, ' ')
      .replace(/<\/(?:p|div|li|h[1-6]|blockquote)>/gi, ' ');
    template.content.querySelectorAll('script, style, template').forEach((node) => node.remove());
    return (template.content.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const insertReviewCard = (anchor, review, index) => {
    const url = mediaUrl(review.media);
    if (!url || grid.querySelector(`[data-dc-ugc-index="${index}"]`)) return;
    const card = document.createElement('a');
    card.className = 'dc-ugc-review-card';
    card.dataset.dcUgcIndex = String(index);
    if (review.productUrl) {
      card.classList.add('dc-ugc-review-link');
      card.href = review.productUrl;
      card.setAttribute('aria-label', 'View product');
    }

    const image = document.createElement('img');
    image.src = url;
    image.alt = review.media?.[0]?.alt || 'Customer styling';
    image.loading = 'lazy';
    image.width = 900;
    image.height = 900;

    const content = document.createElement('div');
    content.className = 'dc-ugc-review-content';
    const stars = document.createElement('p');
    stars.className = 'dc-ugc-review-stars';
    stars.setAttribute('aria-label', `${review.rating || review.score || 5} out of 5 stars`);
    stars.textContent = '★★★★★';
    const quote = document.createElement('p');
    quote.className = 'dc-ugc-review-quote';
    const reviewText = plainReviewText(review.body || review.review_body || review.body_html || review.content || review.text);
    const fullQuote = `“${reviewText}”`;
    quote.textContent = fullQuote;
    if (reviewText.length > 190) {
      quote.classList.add('is-collapsed');
      quote.textContent = `${fullQuote.slice(0, 170).trimEnd()}… `;
      const more = document.createElement('span');
      more.className = 'dc-ugc-review-more';
      more.textContent = 'MORE';
      more.setAttribute('role', 'button');
      more.setAttribute('tabindex', '0');
      more.setAttribute('aria-expanded', 'false');
      const expand = (event) => {
        event.preventDefault();
        event.stopPropagation();
        quote.classList.remove('is-collapsed');
        quote.textContent = fullQuote;
        more.setAttribute('aria-expanded', 'true');
        more.remove();
      };
      more.addEventListener('click', expand);
      more.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') expand(event);
      });
      quote.append(more);
    }
    const author = document.createElement('p');
    author.className = 'dc-ugc-review-author';
    const authorName = document.createElement('strong');
    authorName.textContent = review.author || review.reviewer_name || review.name || 'DIVINCH customer';
    author.append(authorName);
    if (review.verified || review.verified_buyer || review.verifiedBuyer) {
      const verified = document.createElement('span');
      verified.className = 'dc-ugc-review-verified';
      verified.textContent = 'Verified';
      author.append(verified);
    }
    const location = document.createElement('span');
    location.className = 'dc-ugc-review-location';
    const country = String(review.country || review.location || 'United States').replace(/^\(|\)$/g, '');
    location.textContent = `${country} 🇺🇸`;
    author.append(location);

    content.append(stars, quote, author);
    card.append(image, content);
    grid.insertBefore(card, anchor.nextSibling);
  };

  const usedReviewKeys = new Set();
  const reviewKey = (review) => String(
    review.id || review.review_id || mediaUrl(review.media) || `${review.author || review.reviewer_name || ''}|${review.body || review.review_body || review.content || ''}`,
  );

  const renderReviewCards = () => {
    const products = [...grid.querySelectorAll('.product-card')];
    const reviewPool = products.flatMap((product) => {
      const data = product.dataset.judgemeReviewWidgetData || judgeMeReviewData[product.dataset.judgemeProductId] || reviewSource?.dataset.reviewData;
      const productUrl = product.querySelector('.product-card-image')?.href || product.querySelector('.product-card-title-link')?.href || '';
      return collectReviewsWithMedia(parseReviewData(data)).map((review) => ({ ...review, productUrl }));
    });
    if (!reviewPool.length) return;
    products.forEach((product, productIndex) => {
      const index = productIndex + 1;
      if (index % 6 !== 0 || grid.querySelector(`[data-dc-ugc-index="${index}"]`)) return;
      const review = reviewPool.find((candidate) => {
        const key = reviewKey(candidate);
        if (usedReviewKeys.has(key)) return false;
        usedReviewKeys.add(key);
        return true;
      });
      if (review) insertReviewCard(product, review, index);
    });
  };

  renderReviewCards();
  if (!sentinel || !('IntersectionObserver' in window)) return;

  let loading = false;
  let observer;

  const loadNextPage = async () => {
    if (loading) return;
    const nextUrl = sentinel.dataset.nextUrl;
    if (!nextUrl) return;

    loading = true;
    sentinel.classList.add('is-loading');

    try {
      const response = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);

      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = documentFragment.querySelector('.collection-product-grid');
      const nextSentinel = documentFragment.querySelector('[data-dc-infinite-scroll]');

      if (!nextGrid) {
        sentinel.remove();
        observer.disconnect();
        return;
      }

      nextGrid.querySelectorAll('.product-card').forEach((card) => grid.append(card));
      renderReviewCards();
      const followingUrl = nextSentinel?.dataset.nextUrl || '';

      if (followingUrl) {
        sentinel.dataset.nextUrl = followingUrl;
      } else {
        sentinel.remove();
        observer.disconnect();
      }
    } catch (error) {
      console.error('[DIVINCH] Infinite collection load failed', error);
    } finally {
      loading = false;
      sentinel.classList.remove('is-loading');
    }
  };

  observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
  }, { rootMargin: '640px 0px' });

  observer.observe(sentinel);
})();


